

<bci-wk-modal class="modal">

    <img class="war" src="./assets/images/Seal-1.png" alt="waricon" />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title  bciWkTypeH600>{{title}}</bci-wk-modal-title>
    </div>
    <div class="subtitle">
      <p>Vuelve al Inicio y luego haz clic en “Gestionar visitas” para reintentarlo.</p>
    </div>
    <bci-wk-modal-actions>
        <div class="botonera">
            <button (click)="close()" bciWkButtonPrimary>Volver al Inicio</button>
        </div>

    </bci-wk-modal-actions>
  </bci-wk-modal>
